import _slicedToArray from "/runner/_work/gatsby-stop-it-now/gatsby-stop-it-now/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/runner/_work/gatsby-stop-it-now/gatsby-stop-it-now/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { useEffect } from 'react';
var subscribers = [];

var subscribe = function subscribe(filter, callback) {
  if (filter === undefined || filter === null) return undefined;
  if (callback === undefined || callback === null) return undefined;
  subscribers = [].concat(_toConsumableArray(subscribers), [[filter, callback]]);
  return function () {
    subscribers = subscribers.filter(function (subscriber) {
      return subscriber[1] !== callback;
    });
  };
};

var dispatch = function dispatch(event) {
  var type = event.type;
  if (typeof event === 'string') type = event;
  var args = [];
  if (typeof event === 'string') args.push({
    type: type
  });else args.push(event);
  subscribers.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        filter = _ref2[0],
        callback = _ref2[1];

    if (typeof filter === 'string' && filter !== type) return;
    if (Array.isArray(filter) && !filter.includes(type)) return;
    if (filter instanceof RegExp && !filter.test(type)) return;
    if (typeof filter === 'function' && !filter.apply(void 0, args)) return;
    callback.apply(void 0, args);
  });
};

var useBus = function useBus(type, callback) {
  var deps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  useEffect(function () {
    return subscribe(type, callback);
  }, deps);
  return dispatch;
};

export default useBus;
export { dispatch };